<template>
<!-- <div :class="containerClass()">
  <div class="flex flex-row" :class="setEnterAnimation()"> -->
  <div>
    <div class="flex flex-row bg-background-academy">
      <section id="app" class="min-h-screen justify-between flex flex-col w-screen">
        <header-academy  v-model="openMenu">
        </header-academy>
        <div class="w-full h-auto z-10">
          <router-view class="relative"></router-view>
        </div>
        <!-- <notification-container /> -->
        <footer-academy></footer-academy>
      </section>
      <menu-academy class="z-20 right-0 top-0 bottom-0 h-screen fixed"
        v-model="openMenu" :class="moveMenu"/>
    </div>

    <modal resizable name="image-uploader" />

  </div>
</template>

<script>
import HeaderAcademy from '@/components/HeaderAcademy.vue';
// import NotificationContainer from '@/components/notifications/NotificationContainer.vue';
import FooterAcademy from '@/components/FooterAcademy.vue';

import { mapGetters, mapActions } from 'vuex';
import dayjs from 'dayjs';
import MenuAcademy from './components/MenuAcademy.vue';

export default {
  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
      user: 'auth/user',
      teacher: 'auth/teacher',
      student: 'auth/student',
    }),
    moveMenu() {
      if (this.openMenu) {
        return 'animate-translate-in-menu transform';
      }
      if (this.start && !this.openMenu) {
        return 'transform -translate-y-full';
      }
      return 'animate-translate-out-menu transform -translate-y-full';
    },
  },

  data() {
    return {
      openMenu: false,
      start: true,
    };
  },

  mounted() {
    if (this.authenticated) {
      dayjs.locale(this.user.lang);
    }
  },

  components: {
    HeaderAcademy,
    // NotificationContainer,
    FooterAcademy,
    MenuAcademy,
  },

  watch: {
    openMenu() {
      this.start = false;
    },
  },

  methods: {
    ...mapActions({
      addNotification: 'notifications/addFromPusher',
    }),
  },

};
</script>

<style lang="scss">
.vm--modal{
    height: auto !important;
    // top: 30% !important;
  }

.vuecal--date-picker:not(.vuecal--day-view)
.vuecal__cell--selected .vuecal__cell-content {
    background-color: #0F198A;
    color: #fff;
}

#app {
  font-family: 'Assistant', sans-serif;
  font-weight: 300;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

@import 'https://unpkg.com/vue-cal/dist/vuecal.css';
@import 'https://unpkg.com/vue-material/dist/vue-material.min.css';

.past{
  background-color:ivory;
  cursor: pointer;
}

.free{
  background-color:blanchedalmond;
  cursor: pointer;
}

.booked{
  background-color:sandybrown;
  cursor: pointer;
}

.locked{
  background-color:lemonchiffon;
}

.masterclass{
  background-color:rgb(255, 231, 164);
}

.lunch {
  background: repeating-linear-gradient(45deg,
  transparent, transparent 10px, #f2f2f2 10px, #f2f2f2 20px);
  color: #999;
  display: flex;
  justify-content: center;
  align-items: center;

}

.md-select-menu {
  z-index: 2000!important;
}

.vuecal__event.lunch .vuecal__event-time {display: none;align-items: center;}

.vuecal__menu, .vuecal__cell-events-count {background-color: #93162f; color: white}
.vuecal__title-bar {background-color: #bc606f; color: white;}
.vuecal__cell--today, .vuecal__cell--current {background-color: rgba(240, 240, 255, 0.4);}
.vuecal:not(.vuecal--day-view) .vuecal__cell--selected {background-color: #ecebf5;}
.vuecal__cell--selected:before {border-color: #545077;}
/* Cells and buttons get highlighted when an event is dragged over it. */
.vuecal__cell--highlighted:not(.vuecal__cell--has-splits),
.vuecal__cell-split--highlighted {background-color:#545077;}

.vdatetime-popup__header{
  background: #232626!important;
}

.vdatetime-popup__actions__button, .vdatetime-time-picker__item--selected {
  color: #b7b2e6!important;
}

a:hover {
  text-decoration: none !important;
}

.loader {
  color: transparent !important;
  pointer-events: none;
  position: relative;
}

.loader:after {
  animation: spinAround 500ms infinite linear;
  border: 2px solid #dbdbdb;
  border-radius: 290486px;
  border-right-color: transparent;
  border-top-color: transparent;
  content: "";
  display: block;
  width: 1em;
  height: 1em;
  position: absolute;
  left: calc(50% - (1em / 2));
  top: calc(50% - (1em / 2));
}

@keyframes spinAround {
  from {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}
</style>
